import React from "react";
import { motion } from "framer-motion";

const Section = ({ children, bgColor, textColor, comment, isBottom }) => {
  return (
    <motion.div
      initial={{ top: 150 }}
      whileInView={{ top: 0 }}
      viewport={{ once: true }}
      className="relative z-40"
    >
      <p
        className={`${textColor} relative top-1 font-otomanopee text-3xl  rotate-12 origin-top-left text-right z-20`}
      >
        {comment}
      </p>
      <div
        className={`${bgColor} flex justify-center shadow-section relative skew-y-12 box-border w-full pt-20 pb-32 px-4 origin-top-left rounded-t-3xl z-20 md:px-[25%]`}
      >
        <div className="container overflow-hidden -skew-y-12 z-10">
          {children}
        </div>

        {!isBottom && (
          <div
            className={`${bgColor} absolute left-0 -bottom-80 h-96 w-full z-0`}
          ></div>
        )}
      </div>
    </motion.div>
  );
};

export default Section;
